import React from 'react';
import { CheckCircle2, Zap } from 'lucide-react';
export function ProductShowcase() {
  const modules = [{
    title: '⚡ Escaleras Modernas',
    desc: '41 planos detallados de escaleras modernas y minimalistas.'
  }, {
    title: '⚡ Pérgolas y Techos Premium',
    desc: 'Diseños modernos para patios, quinchos y galerías premium.'
  }, {
    title: '⚡ Puertas Modernas Elite',
    desc: 'Puertas premium con estética minimalista y moderna.'
  }, {
    title: '⚡ Portones Corredizos y Levadizos',
    desc: 'Sistemas modernos y funcionales listos para fabricar.'
  }, {
    title: '⚡ Diseños Extra Premium',
    desc: 'Más diseños exclusivos para ampliar todavía más tus trabajos.'
  }];
  const benefits = ['ahorrar horas buscando ideas,', 'tener diseños modernos listos,', 'diferenciarte,', 'y ofrecer trabajos premium que se cobran mejor.'];
  return <section className="py-7 md:py-12 px-3 bg-brand-card border-y border-brand-accent/20" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <div className="flex justify-center mb-4" data-id="element-136">
          <div className="bg-brand-accent/20 border border-brand-accent text-brand-accent font-black px-4 py-1 rounded-full text-[10px] md:text-sm tracking-widest uppercase flex items-center" data-id="element-137">
            <Zap className="w-3.5 h-3.5 mr-1.5" data-id="element-138" />
            💡 LA SOLUCIÓN
          </div>
        </div>

        <h2 className="text-xl md:text-4xl font-black text-center mb-3 text-white uppercase tracking-tight leading-tight" data-id="element-139">
          MEGA PACK{' '}
          <span className="text-brand-accent neon-glow" data-id="element-140">HERRERÍA MODERNA</span>
        </h2>

        <p className="text-sm md:text-lg text-gray-300 mb-6 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-141">
          Una colección completa de diseños premium pensada para herreros y
          talleres que quieren ofrecer trabajos mucho más modernos y
          profesionales.
        </p>

        <div className="bg-brand-dark rounded-xl border-2 border-brand-accent p-4 md:p-7 shadow-[0_0_25px_rgba(212,161,75,0.15)] mb-7" data-id="element-142">
          <h3 className="text-base md:text-2xl font-black text-white mb-4 text-center" data-id="element-143">
            Con este sistema vas a poder:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5" data-id="element-144">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-center bg-brand-card p-3 rounded-md border border-white/5" data-id="element-145">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2.5 shrink-0" data-id="element-146" />
                <span className="text-xs md:text-base font-bold text-white" data-id="element-147">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-5" data-id="element-148">
          <h3 className="text-lg md:text-3xl font-black text-white inline-block border-b-2 border-brand-accent pb-1 uppercase" data-id="element-149">
            🎁 TODO LO QUE RECIBÍS
          </h3>
        </div>

        <div className="space-y-2.5" data-id="element-150">
          {modules.map((mod, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-lg p-3.5 md:p-5 hover:border-brand-accent transition-colors flex items-start md:items-center gap-3" data-id="element-151">
              <div className="bg-brand-accent/10 p-2 md:p-2.5 rounded-md shrink-0" data-id="element-152">
                <span className="text-lg md:text-2xl" data-id="element-153">🛠️</span>
              </div>
              <div data-id="element-154">
                <h4 className="text-sm md:text-xl font-black text-brand-neon mb-1 uppercase leading-tight" data-id="element-155">
                  {mod.title}
                </h4>
                <p className="text-xs md:text-base text-gray-300 font-medium leading-snug" data-id="element-156">
                  {mod.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}